// src/pages/championships/MatchesToday.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './MatchesToday.css';

const formatTime = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return ' --:-- ';
    return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return ' --:-- ';
  }
};

const normalizeStatus = (status) => {
    if (!status) return 'scheduled';
    const normalized = status.toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/_/g, '-');
    return normalized;
};

function MatchesToday({ matches, championshipId }) {
  if (!matches || matches.length === 0) {
    const today = new Date();
    const todayDisplay = today.toLocaleDateString('pt-BR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    
    return (
      <div className="matches-today-card card-style no-matches">
        <h3>Partidas de Hoje ({todayDisplay})</h3>
        <p>Nenhuma partida agendada para hoje neste campeonato.</p>
      </div>
    );
  }

  const today = new Date();
  const todayDisplay = today.toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div className="matches-today-card card-style">
      <h3>Partidas de Hoje ({todayDisplay})</h3>
      <div className="matches-list">
        {matches.map(match => {
          // Determina o status da partida
          const matchStatus = match.status || 'scheduled';
          const normalizedStatus = normalizeStatus(matchStatus);
          
          // Verifica se está em andamento
          const isLive = normalizedStatus.includes('progress') || 
                        normalizedStatus.includes('andamento') || 
                        normalizedStatus.includes('live');
          
          // Verifica se está finalizada
          const isCompleted = normalizedStatus.includes('completed') || 
                             normalizedStatus.includes('finalizado') || 
                             normalizedStatus.includes('concluído') ||
                             normalizedStatus.includes('encerrado');

          // Obtém os times (suporta múltiplos formatos de propriedades)
          const homeTeam = match.homeTeam || match.teamA || {};
          const awayTeam = match.awayTeam || match.teamB || {};
          
          // Obtém os scores (suporta múltiplos formatos de propriedades)
          const homeScore = match.scoreA !== undefined ? match.scoreA : 
                           match.homeScore !== undefined ? match.homeScore : '-';
          const awayScore = match.scoreB !== undefined ? match.scoreB : 
                           match.awayScore !== undefined ? match.awayScore : '-';

          return (
            <Link 
              to={`/championships/${championshipId}/matches/${match._id}`} 
              key={match._id} 
              className="match-today-item-link"
            >
              <div className={`match-today-item status-${normalizedStatus}`}>
                <div className="match-time">
                  {formatTime(match.date)}
                </div>
                
                {/* Time da casa */}
                <div className="team-info home-team">
                  <span>{homeTeam.name || 'A Definir'}</span>
                  <img 
                    src={homeTeam.badge || '/default-team-logo.png'} 
                    alt={homeTeam.name || 'Time da Casa'}
                    onError={(e) => e.target.src = '/default-team-logo.png'}
                  />
                </div>
                
                {/* Placar */}
                <div className="match-score">
                  <span>{homeScore}</span>
                  <span>x</span>
                  <span>{awayScore}</span>
                </div>
                
                {/* Time visitante */}
                <div className="team-info away-team">
                  <img 
                    src={awayTeam.badge || '/default-team-logo.png'} 
                    alt={awayTeam.name || 'Time Visitante'}
                    onError={(e) => e.target.src = '/default-team-logo.png'}
                  />
                  <span>{awayTeam.name || 'A Definir'}</span>
                </div>
                
                {/* Status da partida */}
                <div className="match-status-indicator">
                  {isLive && <span className="live-dot"></span>}
                  {isLive ? 'AO VIVO' : 
                   isCompleted ? 'Encerrado' : 
                   'Agendado'}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}

MatchesToday.propTypes = {
  matches: PropTypes.array.isRequired,
  championshipId: PropTypes.string.isRequired,
};

export default MatchesToday;